/**
 *  search.serv.js
 */

class SearchBoxServ {
    
    constructor() {
        this.searchBoxConfig = {
        	searchBox: {
	            'bounds': new google.maps.LatLngBounds(new google.maps.LatLng(47.925176, 20.706121), new google.maps.LatLng(43.740939, 28.561345)),
	            'componentRestrictions': {
	            	'country': 'ro'
	            }
        	},
        	automcomplete: {
        		types: ['geocode'],
	            componentRestrictions: {
	                country: 'ro'
	            }
        	}
        };
    }
    
    readSearchBoxConfig() {
        return this.searchBoxConfig;
    }
}

export default SearchBoxServ;